import React from 'react';
import {useDispatch} from 'react-redux';
import {Link, useHistory} from 'react-router-dom';
import {AppDispatch} from '~/redux/root-store';
import {useNotification} from '~/hooks';
import {Col, UiBox, UiCenter, UiLink, UiText} from '~/components/elements';

const NotFoundPage = () => {
  const dispatch: AppDispatch = useDispatch();
  const {addMessage} = useNotification(dispatch);
  const history = useHistory();
  // const { loading } = useSelector((state: RootState) => state.ui[.typePrefix] || {});

  return (
    <Col h="100vh">
      <UiCenter flex={1}>
        <Col px={4} textAlign="center">
          <UiText variant="h1">Lost in Space?</UiText>
          <UiText>
            The page you requested could not be found, but don&apos;t worry! You can always{' '}
            <UiLink as={Link} to="/">
              go home
            </UiLink>
            .
          </UiText>
        </Col>
      </UiCenter>
    </Col>
  );
};

export default NotFoundPage;
